var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.claim.visuals
    ? _c(
        "div",
        { class: _vm.customiseClass ? _vm.customiseClass : "pb-1" },
        _vm._l(_vm.claim.visuals, function (visual, index) {
          return _c(
            "div",
            {
              key: visual.id,
              staticClass: "border-bleu",
              class: _vm.isBlack ? "bg-gray1" : "bg-gray2",
            },
            [
              _c("div", { staticClass: "col-12 px-0 visual-claim-border" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center claim-padding" },
                  [
                    _c(
                      "div",
                      {
                        key: visual.id,
                        staticClass:
                          "image-wrapper d-flex justify-content-center align-items-center pe-1",
                      },
                      [
                        _c("img", {
                          staticClass: "visual-claim-img",
                          attrs: {
                            loading: "lazy",
                            src: visual.url,
                            alt: visual.alt,
                            "aria-hidden": "true",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-wrapper" }, [
                      _c("span", {
                        directives: [
                          {
                            name: "msh-html",
                            rawName: "v-msh-html",
                            value: _vm.claim.attributes[index]
                              ? _vm.claim.attributes[index].textHtml
                              : "",
                            expression:
                              "claim.attributes[index] ? claim.attributes[index].textHtml : ''",
                          },
                        ],
                        staticClass: "small",
                      }),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        }),
        0
      )
    : _c("div", { class: _vm.customiseClass ? _vm.customiseClass : "pb-1" }, [
        _c(
          "div",
          {
            staticClass: "border-bleu",
            class: _vm.isBlack ? "bg-gray1" : "bg-gray2",
          },
          [
            _vm._l(_vm.claim.attributes, function (attribute, index) {
              return [
                _c(
                  "div",
                  {
                    key: index,
                    staticClass:
                      "d-flex align-items-center justify-content-start",
                  },
                  [
                    _c("span", {
                      directives: [
                        {
                          name: "msh-html",
                          rawName: "v-msh-html",
                          value: attribute.textHtml,
                          expression: "attribute.textHtml",
                        },
                      ],
                      staticClass: "small claim-padding",
                    }),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }